var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
export const Button = (_a) => {
    var { children, onClick, className = '', tabIndex = 0, icon } = _a, rest = __rest(_a, ["children", "onClick", "className", "tabIndex", "icon"]);
    const ref = useRef(null);
    function handleClick(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        setTimeout(() => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 300);
    }
    return (React.createElement("button", Object.assign({ ref: ref, onClick: handleClick, className: `adapter-react-button ${className}`, tabIndex: tabIndex }, rest),
        icon && (React.createElement("i", { className: "button-icon" },
            React.createElement("img", { src: icon }))),
        children));
};
//# sourceMappingURL=Button.js.map